import { DEMO_LP } from "../../data/portalDemo.js";

export default function PortalAccount() {
  return (
    <div className="portal-page">
      <h1 className="portal-h1">Account</h1>

      <section className="portal-card">
        <h2 className="portal-h2">Investor profile</h2>
        <table className="portal-keyval">
          <tbody>
            <tr><th>Name</th><td>{DEMO_LP.name}</td></tr>
            <tr><th>Primary contact</th><td>{DEMO_LP.contact}</td></tr>
            <tr><th>Email</th><td>{DEMO_LP.email}</td></tr>
            <tr><th>Jurisdiction</th><td>{DEMO_LP.jurisdiction}</td></tr>
          </tbody>
        </table>
      </section>

      <section className="portal-card">
        <h2 className="portal-h2">KYC / AML</h2>
        <table className="portal-keyval">
          <tbody>
            <tr><th>Status</th><td><span className="pill pill-good">{DEMO_LP.kycStatus}</span></td></tr>
            <tr><th>Last verified</th><td>{DEMO_LP.kycDate}</td></tr>
            <tr><th>Next review</th><td>2027-01-14</td></tr>
          </tbody>
        </table>
      </section>

      <section className="portal-card">
        <h2 className="portal-h2">Investing entities</h2>
        <table className="portal-table">
          <thead><tr><th>Entity</th><th>Role</th><th></th></tr></thead>
          <tbody>
            {DEMO_LP.entities.map(e => (
              <tr key={e.id}>
                <td>{e.name}</td>
                <td className="muted">{e.primary ? "Primary investor" : "Secondary"}</td>
                <td><a href="#" className="portal-rowlink">Manage →</a></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="portal-card">
        <h2 className="portal-h2">Banking instructions</h2>
        <p className="muted">Wire instructions are stored per-fund. Please review on each fund detail page.</p>
      </section>

      <section className="portal-card">
        <h2 className="portal-h2">Communication preferences</h2>
        <table className="portal-keyval">
          <tbody>
            <tr><th>Quarterly statements</th><td>Email + portal notification</td></tr>
            <tr><th>Capital call notices</th><td>Email + portal notification</td></tr>
            <tr><th>Distribution notices</th><td>Email + portal notification</td></tr>
            <tr><th>Investor letters</th><td>Email</td></tr>
          </tbody>
        </table>
      </section>
    </div>
  );
}
